import type { ReactNode } from 'react';
import React from 'react';
import type { Theme } from '@material-ui/core';
import { useKlpStyles } from '@klp/design/Theme/useKlpStyles';

const styles = (theme: Theme) => ({
    wrapper: {
        position: 'relative',
        height: '100%',
    },
    skeleton: {
        position: 'absolute',
        top: 0,
        left: 0,
        height: '100%',
        width: '100%',
        backgroundColor: theme.palette.secondary.veryLight,
        animation: '$flash 1.5s infinite ease-in-out',
        zIndex: 1,
        opacity: 0.5,
    },
    '@keyframes flash': {
        '0%': {
            backgroundColor: theme.palette.secondary.veryLight,
        },
        '50%': {
            backgroundColor: theme.palette.secondary.light,
        },
        '100%': {
            backgroundColor: theme.palette.secondary.veryLight,
        },
    },
});

export type SkeletonProps = {
    isLoading: boolean;
    children: ReactNode;
};

export const Skeleton: React.FC<SkeletonProps> = ({ isLoading, children }) => {
    const classes = useKlpStyles({}, styles);

    return (
        <div className={classes.wrapper}>
            {isLoading && <div className={classes.skeleton} />}
            {children}
        </div>
    );
};
